import React, { useEffect, useRef, useState } from 'react';
import { Input, Button, message, Row, Col } from 'antd';
import { setBlackUser } from '../../../api/inspiration'

export default () => {
  const [loading, setLoading] = useState(false)
  const [accountURL, setAccountURL] = useState('')
  const getUsername = () => {
    return localStorage.getItem('username');
  };
  const handleClick = () => {
    if (!accountURL) return
    let accountURLarr = accountURL.replaceAll('，', ',').split(',')
    setLoading(true)
    try {
      setBlackUser({ homePageUrls: accountURLarr }, getUsername()).then(res => {
        if (res.error.code == 0) {
          if (res?.data?.length) {
            message.warning(`操作失败，账号${res?.data?.toString()}错误`)
          } else {
            message.success('操作成功')
            setAccountURL('')
          }
        } else {
          message.error(res.error.message)
        }
      }).finally(() => {
        setLoading(false)
      })
    } catch (error) { }
  }

  return <div style={{ height: '100vh' }}>
    <Row
      style={{
        marginBottom: 50,
      }}
    >
      <h1
        style={{
          fontSize: 40,
          margin: 0,
        }}
      >黑名单管理</h1>
    </Row>
    <Row>
      <Col span={4} style={{ marginBottom: 10 }}>
        <Input placeholder='请输入P站账号URL' value={accountURL} onChange={(e) => { setAccountURL(e.target.value) }} /></Col>
    </Row>
    <Row>
      <div style={{ marginBottom: 10 }}>注：提交删除后，该账号下的内容将不再进行爬取，且该账号往期爬取的所有图集、图片将进行删除处理</div>
    </Row>
    <Row>
      <Col span={4}>
        <Button type="primary" loading={loading} onClick={() => handleClick()}>
          点击删除账号
        </Button></Col>
    </Row>
  </div>
}